import PerformanceLevel from "../../../../lib/html5-software-library/src/ranj/performance/PerformanceLevel";
import BrowserDetect from "../../../../lib/html5-software-library/src/ranj/util/BrowserDetect";
import StageManager from "../../../../lib/html5-software-library/src/ranj/performance/StageManager";
import AppInstaller from './AppInstaller';
import MediatorMapping from './MediatorMapping';
import ContextEvent from './ContextEvent';
import Stats from 'stats-js/build/stats';
import GameEvent from './GameEvent';
import soma from 'soma.js/build/soma';

const canvasIds = ['mainGameCanvas'];
const fallbackAudioExtensions = ['mp3', 'wav'];

export default class App extends soma.Application {
    constructor() {
        super();
    }

    init() {
        //TODO: dont use global. We keep this for now, because a lot of classes rely on log being in window scope...
        window.log = console;

        // Defines the extension 'next in line' in the browser doesn't support the audio type defined in 'assets.json' (e.g. '.ogg').
        createjs.Sound.alternateExtensions = fallbackAudioExtensions;

        this.setupCanvasForMobile();

        // Create the stages and context view
        // Note: having several stages is usually related to optimizing the game for best performance -- See StageManager for details on how to do it.
        // Or a second canvas/stage is used for overlaying video controls
        var enableTouch = createjs.Touch.isSupported();
        console.info("App.init: Touch enabled: " + enableTouch);
        var stages = this.createStages(canvasIds, enableTouch);

        // Initialize StageManager (to handle stage updates)
        const fps = 60;
        var stageManager = new StageManager(stages, fps, PerformanceLevel.MEDIUM);
        stageManager.enableAllStagesMouseOver(BrowserDetect.isMobile() ? 0 : 10);
        this.injector.mapValue("stageManager", stageManager);

        // Create the screenNavigator with the contextView and map it
        // The screen navigator requires a contextView, this we can't map
        // against the class, but instead we need to map a particular instance.
        var stage = stages[canvasIds[0]];
        this.injector.mapValue("stage", stage);

        const mediatorMap = new MediatorMapping();
        this.injector.mapValue("mediatorMap", mediatorMap);

        // Mapping the other dependencies.
        this.injector.createInstance(AppInstaller);

        //Dont use onunload because it is not properly supported on all platforms and comes too late.
        //NB: onbeforeunload not supported on mobile safari
        window.onbeforeunload = this.destroy.bind(this);

        if (ranj.DEBUG) {
            this.initDebug();
            //add Debug stats
            this.addStats();
        }
    }

    start() {
        console.log('app start');

        this.dispatcher.dispatch(ContextEvent.STARTUP, { data: canvasIds });
    }

    destroy() {
        console.log("app destroy");
        this.dispatcher.dispatch(ContextEvent.DESTROY);
    }

    /**
     * Create stages for specified canvas objects.
     * @param {Array} canvasIds Ids of canvas objects
     * @param {Boolean} enableTouch 
     * @returns {Array} Array of stages
     */
    createStages(canvasIds, enableTouch) {
        //NB: canvasIds should be ordered by ascending z-index for mouse interaction to work properly!
        var stages = {};
        var stageLast;
        this.canvases = [];//keep ref for resizing
        this.stages = stages;//keep ref for resizing
        for (var i = 0; i < canvasIds.length; i++) {
            var id = canvasIds[i];
            var canvas = document.getElementById(id);
            this.canvases.push(canvas);
            var stage = new createjs.Stage(canvas);
            stages[id] = stage;
            var view = this.generateContextView(id);
            stage.addChild(view);
            // Keep tracking the mouse even when it leaves the canvas
            stage.mouseMoveOutside = true;
            // Can be disabled if you know the project is desktop ONLY. Enabling touch is a performance hit.
            if (enableTouch) createjs.Touch.enable(stage);
            //
            if (stageLast) {
                stage.nextStage = stageLast;//this will detect mouseevents through stages
                //Make sure the zorder of the stages doesnt change because the
                //stage.nextStage stuff will become invalid!
            }
            stageLast = stage;
        }
        return stages;
    }

    generateContextView() {
        return new createjs.Container();
    }

    initDebug() {
        //Listen to debug key strokes
        window.addEventListener("keyup", this.handleKeyUp.bind(this));
    }


    addStats() {
        this.stats = new Stats();

        const domElement = this.stats.dom;
        domElement.style.top = null;
        domElement.style.left = null;
        domElement.style.right = '0px';
        domElement.style.bottom = '0px';

        document.body.appendChild(domElement);

        if (!this.updateStats) {
            this.updateStats = () => { this.stats.update(); }
        }
        createjs.Ticker.addEventListener("tick", this.updateStats);
    }

    removeStats() {
        if (this.stats) {
            document.body.removeChild(this.stats.domElement);
            this.stats = null;
            createjs.Ticker.removeEventListener("tick", this.updateStats);
        }
    }

    handleKeyUp(e) {
        //only while DEBUG true!
        if (e.altKey && e.ctrlKey && e.shiftKey) {
            var c = String.fromCharCode(e.which);
            if (c == "P")
                this.dispatcher.dispatch(GameEvent.PAUSE_GAME);//pause game
            else if (c == "R")
                this.dispatcher.dispatch(GameEvent.RESUME_GAME);//resume
        }
    }

    setupCanvasForMobile() {
        for (let i = 0; i < canvasIds.length; i++) {
            const obj = document.getElementById(canvasIds[i]);
            const block = function (e) { return false; };
            obj.ontouchstart = block;
            obj.ontouchmove = block;
            obj.onselectstart = block; // prevent DOM around the canvas to be selected when the canvas is double clicked
        }
    }
}